module.exports = __webpack_public_path__ + "static/toni-1265360a11a5ef24bff467433c26d589.jpg";